var $c68983ae60668f02$exports = {};
$c68983ae60668f02$exports = {
    "colorSwatchPicker": `Amostras de cores`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecione um item`,
    "tableResizer": `Redimensionador`
};


export {$c68983ae60668f02$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
